export const customersLogos = {
  accel: {
    src: '/static/images/logos/investors/accel.svg',
    alt: 'accel',
    width: 72,
    height: 23
  },
  accenture: {
    src: '/static/images/logos/investors/accenture.svg',
    alt: 'accenture',
    width: 111,
    height: 29
  },
  koch: {
    src: '/static/images/logos/investors/koch.svg',
    alt: 'koch logo',
    width: 130,
    height: 20
  },
  adept: {
    src: '/static/images/logos/investors/adept.png',
    alt: 'adept',
    width: 75,
    height: 36
  },
  opensea: {
    src: '/static/images/logos/investors/opensea.svg',
    alt: 'opensea',
    width: 127,
    height: 29
  },
  entrupy: {
    src: '/static/images/logos/investors/entrupy.svg',
    alt: 'opensea',
    width: 109,
    height: 29
  },
  carper: {
    src: '/static/images/logos/investors/carper.png',
    alt: 'carper',
    width: 110,
    height: 25
  },
  coatue: {
    src: '/static/images/logos/investors/coatue.svg',
    alt: 'coatue',
    width: 81,
    height: 15
  },
  cohere: {
    src: '/static/images/logos/investors/cohere.svg',
    alt: 'cohere',
    width: 109,
    height: 18
  },
  durable: {
    src: '/static/images/logos/investors/durable.svg',
    alt: 'durable',
    width: 109,
    height: 26
  },
  faire: {
    src: '/static/images/logos/investors/faire.svg',
    alt: 'faire',
    width: 115,
    height: 19
  },
  foundersfund: {
    src: '/static/images/logos/investors/founders-fund.svg',
    alt: 'foundersfund',
    width: 138,
    height: 14
  },
  characterai: {
    src: '/static/images/logos/customers/characterai.svg',
    alt: 'character ai',
    width: 129,
    height: 18
  },
  fox: {
    src: '/static/images/logos/investors/fox.svg',
    alt: 'fox',
    width: 71,
    height: 29
  },
  greenoaks: {
    src: '/static/images/logos/investors/greenoaks.svg',
    alt: 'greenoaks',
    width: 102,
    height: 40
  },
  indexventures: {
    src: '/static/images/logos/investors/index-ventures.svg',
    alt: 'indexventures',
    width: 126,
    height: 18
  },
  sparkcapital: {
    src: '/static/images/logos/investors/spark-capital.svg',
    alt: 'spark capital',
    width: 122,
    height: 9
  },
  thrivecapital: {
    src: '/static/images/logos/investors/thrive-capital.svg',
    alt: 'thrive capital',
    width: 100,
    height: 13
  },
  tigerglobal: {
    src: '/static/images/logos/investors/tiger-global.svg',
    alt: 'tiger global',
    width: 115,
    height: 12
  },
  wellington: {
    src: '/static/images/logos/investors/wellington-management.svg',
    alt: 'wellington management',
    width: 116,
    height: 24
  },
  ycombinator: {
    src: '/static/images/logos/investors/y-combinator.svg',
    alt: 'y combinator',
    width: 123,
    height: 26
  },
  dragoneer: {
    src: '/static/images/logos/investors/dragoneer.svg',
    alt: 'dragoneer',
    width: 92,
    height: 50
  },
  airbnb: {
    src: '/static/images/logos/customers/airbnb.svg',
    alt: 'airbnb',
    width: 78,
    height: 25
  },
  airforce: {
    src: '/static/images/logos/customers/airforce.svg',
    alt: 'airforce',
    width: 65,
    height: 51
  },
  aptiv: {
    src: '/static/images/logos/customers/aptiv.svg',
    alt: 'aptiv',
    width: 101,
    height: 13
  },
  aurora: {
    src: '/static/images/logos/customers/aurora.svg',
    alt: 'aurora',
    width: 88,
    height: 31
  },
  baidu: {
    src: '/static/images/logos/customers/baidu.svg',
    alt: 'baidu',
    width: 105,
    height: 30
  },
  brex: {
    src: '/static/images/logos/customers/brex.svg',
    alt: 'brex',
    width: 72,
    height: 20
  },
  cdao: {
    src: '/static/images/logos/customers/cdao.svg',
    alt: 'cdao',
    width: 113,
    height: 30
  },
  cellareye: {
    src: '/static/images/logos/customers/cellareye.svg',
    alt: 'cellareye',
    width: 105,
    height: 24
  },
  collectability: {
    src: '/static/images/logos/customers/collectability.svg',
    alt: 'collectability',
    width: 160,
    height: 11
  },
  defense: {
    src: '/static/images/logos/customers/defense-innovation-unit.svg',
    alt: 'defense innovation unit',
    width: 120,
    height: 14
  },
  doordash: {
    src: '/static/images/logos/customers/doordash.svg',
    alt: 'doordash',
    width: 120,
    height: 14
  },
  embark: {
    src: '/static/images/logos/customers/embark.svg',
    alt: 'embark',
    width: 162,
    height: 47
  },
  etsy: {
    src: '/static/images/logos/customers/etsy.svg',
    alt: 'etsy',
    width: 48,
    height: 23
  },
  flexport: {
    src: '/static/images/logos/customers/flexport.svg',
    alt: 'flexport',
    width: 80,
    height: 18
  },
  gm: {
    src: '/static/images/logos/customers/general-motors.svg',
    alt: 'general-motors',
    width: 36,
    height: 36
  },
  grata: {
    src: '/static/images/logos/customers/grata.svg',
    alt: 'grata',
    width: 144,
    height: 42
  },
  honda: {
    src: '/static/images/logos/customers/honda.svg',
    alt: 'honda',
    width: 84,
    height: 26
  },
  instacart: {
    src: '/static/images/logos/customers/instacart.svg',
    alt: 'instacart',
    width: 111,
    height: 22
  },
  keeptruckin: {
    src: '/static/images/logos/customers/keeptruckin.svg',
    alt: 'keeptruckin',
    width: 201,
    height: 33
  },
  linkedin: {
    src: '/static/images/logos/customers/linkedin.svg',
    alt: 'linkedin',
    width: 88,
    height: 38
  },
  luminar: {
    src: '/static/images/logos/customers/luminar.svg',
    alt: 'luminar',
    width: 88,
    height: 29
  },
  lyft: {
    src: '/static/images/logos/customers/lyft.svg',
    alt: 'lyft',
    width: 46,
    height: 31
  },
  continental: {
    src: '/static/images/logos/customers/continental.svg',
    alt: 'lyft',
    width: 150,
    height: 27
  },
  meta: {
    src: '/static/images/logos/customers/meta.svg',
    alt: 'meta',
    width: 90,
    height: 20
  },
  mlconf: {
    src: '/static/images/logos/customers/mlconf.svg',
    alt: 'mlconf',
    width: 102,
    height: 37
  },
  mlops: {
    src: '/static/images/logos/customers/mlops.svg',
    alt: 'mlops',
    width: 65,
    height: 81
  },
  nuro: {
    src: '/static/images/logos/customers/nuro.svg',
    alt: 'nuro',
    width: 57,
    height: 16
  },
  nvidia: {
    src: '/static/images/logos/customers/nvidia.svg',
    alt: 'nvidia',
    width: 100,
    height: 18
  },
  openai: {
    src: '/static/images/logos/customers/openai.svg',
    alt: 'openai',
    width: 108,
    height: 28
  },
  doma: {
    src: '/static/images/logos/customers/doma.svg',
    alt: 'doma',
    width: 83,
    height: 21
  },
  optimusRide: {
    src: '/static/images/logos/customers/optimus-ride.svg',
    alt: 'optimus-ride',
    width: 130,
    height: 33
  },
  oshkosh: {
    src: '/static/images/logos/customers/oshkosh.svg',
    alt: 'oshkosh',
    width: 96,
    height: 32
  },
  paypal: {
    src: '/static/images/logos/customers/paypal.svg',
    alt: 'paypal',
    width: 82,
    height: 21
  },
  pinterest: {
    src: '/static/images/logos/customers/pinterest.svg',
    alt: 'pinterest',
    width: 100,
    height: 24
  },
  samsung: {
    src: '/static/images/logos/customers/samsung.svg',
    alt: 'samsung',
    width: 88,
    height: 24
  },
  sap: {
    src: '/static/images/logos/customers/sap.svg',
    alt: 'sap',
    width: 60,
    height: 30
  },
  seamachines: {
    src: '/static/images/logos/customers/seamachines.svg',
    alt: 'seamachines',
    width: 139,
    height: 30
  },
  skydio: {
    src: '/static/images/logos/customers/skydio.svg',
    alt: 'skydio',
    width: 100,
    height: 27
  },
  square: {
    src: '/static/images/logos/customers/square.svg',
    alt: 'square',
    width: 90,
    height: 23
  },
  stability: {
    src: '/static/images/logos/investors/stability.png',
    alt: 'stability',
    width: 115,
    height: 39
  },
  standardCognition: {
    src: '/static/images/logos/customers/standard-cognition.svg',
    alt: 'standard-cognition',
    width: 145,
    height: 80
  },
  statesTitle: {
    src: '/static/images/logos/customers/states-title.svg',
    alt: 'states-title',
    width: 147,
    height: 81
  },
  timbereye: {
    src: '/static/images/logos/customers/timbereye.svg',
    alt: 'timbereye',
    width: 166,
    height: 21
  },
  toyota: {
    src: '/static/images/logos/customers/toyota.svg',
    alt: 'toyota',
    width: 76,
    height: 25
  },
  tribe: {
    src: '/static/images/logos/customers/tribe.svg',
    alt: 'tribe',
    width: 102,
    height: 30
  },
  uncountable: {
    src: '/static/images/logos/customers/uncountable.svg',
    alt: 'uncountable',
    width: 150,
    height: 34
  },
  usarmy: {
    src: '/static/images/logos/customers/usarmy.svg',
    alt: 'usarmy',
    width: 40,
    height: 40
  },
  valeo: {
    src: '/static/images/logos/customers/valeo.svg',
    alt: 'valeo',
    width: 78,
    height: 34
  },
  voyage: {
    src: '/static/images/logos/customers/voyage.svg',
    alt: 'voyage',
    width: 157,
    height: 40
  },
  x2: {
    src: '/static/images/logos/customers/x2.svg',
    alt: 'x2',
    width: 100,
    height: 107
  },
  zenuity: {
    src: '/static/images/logos/customers/zenuity.svg',
    alt: 'zenuity',
    width: 115,
    height: 25
  },
  zf: {
    src: '/static/images/logos/customers/zf.svg',
    alt: 'zf',
    width: 50,
    height: 50
  },
  zoox: {
    src: '/static/images/logos/customers/zoox.svg',
    alt: 'zoox',
    width: 80,
    height: 15
  },
  magna: {
    src: '/static/images/pages/homepage/logos/magna.svg',
    alt: 'magna',
    width: 250,
    height: 51
  },
  microsoft: {
    src: '/static/images/logos/customers/microsoft.svg',
    alt: 'microsoft',
    width: 100,
    height: 22
  }
};
